import { convertToOOXML } from "./OOXML";
export function maxAbstractId(nodes, max = 0) {
    if (nodes?._children?.length) nodes._children.forEach(node => {
        if (node._tag === 'w:abstractNum') {
            max = Math.max(max, parseInt(node._attrs['w:abstractNumId']));
        }
        max = maxNumId(node, max);
    });
    return max;
}

export function maxNumId(nodes, max = 0) {
    if (nodes?._children?.length) nodes._children.forEach(node => {
        if (node._tag === 'w:numId') {
            max = Math.max(max, parseInt(node._attrs['w:val']));
        }
        max = maxNumId(node, max);
    });
    return max;
}

export function removeNumId(maxNumId, xml) {
    if (xml._tag === 'w:numbering') {
        xml.children = xml._children.filter(childNode => {
            return removeNumId(maxNumId, childNode);
        });
    } else {
        return xml._children.every(childNode => {
            if(childNode._tag === 'w:numId') {
                return parseInt(childNode._attrs['w:val']) <= maxNumId
            } else if (!childNode._fTextNode) {
                return removeNumId(maxNumId, childNode);
            } 
            return true;
            
        });
    }
}

export function abstractOrderedList(id, parentOOXML) {
    return convertToOOXML({
        tag: "w:abstractNum",
        attrs: {"w:abstractNumId": id},
        children: [
            {tag: "w:lvl", attrs: {"w:ilvl": "0"}, children: [
                {tag: "w:start", attrs: {"w:val": "1"}},
                {tag: "w:numFmt", attrs: {"w:val": "decimal"}},
                {tag: "w:lvlText", attrs: {"w:val": "%1."}},
                {tag: "w:lvlJc", attrs: {"w:val": "left"}}
            ]},
            {tag: "w:lvl", attrs: {"w:ilvl": "1"}, children: [
                {tag: "w:start", attrs: {"w:val": "1"}},
                {tag: "w:numFmt", attrs: {"w:val": "lowerLetter"}},
                {tag: "w:lvlText", attrs: {"w:val": "%2."}},
                {tag: "w:lvlJc", attrs: {"w:val": "left"}}
            ]},
            {tag: "w:lvl", attrs: {"w:ilvl": "2"}, children: [
                {tag: "w:start", attrs: {"w:val": "1"}},
                {tag: "w:numFmt", attrs: {"w:val": "lowerRoman"}},
                {tag: "w:lvlText", attrs: {"w:val": "%3."}},
                {tag: "w:lvlJc", attrs: {"w:val": "left"}}
            ]}
        ]
    }, parentOOXML);
}

export function abstractUnorderedList(id, parentOOXML) {
    return convertToOOXML({
        tag: "w:abstractNum",
        attrs: {"w:abstractNumId": id},
        children: [
            {tag: "w:lvl", attrs: {"w:ilvl": "0"}, children: [
                {tag: "w:numFmt", attrs: {"w:val": "bullet"}},
                {tag: "w:lvlText", attrs: {"w:val": "•"}},
                {tag: "w:lvlJc", attrs: {"w:val": "left"}}
            ]}
        ]
    }, parentOOXML);
}

export function numberingDetail(id, abstractId, parentOOXML) {
    return convertToOOXML({
        tag: "w:num",
        attrs: {"w:numId": id},
        children: [
            {tag: "w:abstractNumId", attrs: {"w:val": abstractId}}
        ]
    }, parentOOXML);
}

export function px2OOXML(px) {
    return Number(px.replace("px", "")) * 12;
}

export function encodeXml(text) {
    // Define a regex to match non-standard XML characters
    const nonStandardRegex = /[^\u0020-\uD7FF\uE000-\uFFFD]/g;
    let encodedText = text.replace(/&(?!amp;)/g, '&amp;')  // Encode ampersand
        .replace(/</g, '&lt;')   // Encode less than
        .replace(/>/g, '&gt;')   // Encode greater than
        .replace(/"/g, '&quot;')  // Encode double quote
        .replace(/'/g, '&apos;'); // Encode single quote;

    // Replace non-standard characters using a while loop
    while (nonStandardRegex.test(encodedText)) {
        encodedText = encodedText.replace(nonStandardRegex, (match) => {
            return `&#x${match.charCodeAt(0).toString(16).toUpperCase()};`;
        });
    }

    // Encode standard XML characters
    return encodedText;
        
}
